import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';

export type ApplicationVersionSliceInitialState = {
  applicationVersionNumber: string;
  latestBuildTimestamp: number;
};

export const applicationVersionInitialState: ApplicationVersionSliceInitialState =
  {
    applicationVersionNumber: '',
    latestBuildTimestamp: 0,
  };

export const applicationVersionSlice = createSlice({
  name: 'applicationVersion',
  initialState: applicationVersionInitialState,
  reducers: {
    setApplicationVersionNumber(state, action: PayloadAction<string>) {
      state.applicationVersionNumber = action.payload;
    },
    setLatestBuildTimestamp(state, action: PayloadAction<number>) {
      state.latestBuildTimestamp = action.payload;
    },
  },
});

export const invalidateApplicationCacheIfNeeded = createAction<{
  accessToken: string;
}>('INVALIDATE_APPLICATION_CACHE_IF_NEEDED');

export const { setApplicationVersionNumber, setLatestBuildTimestamp } =
  applicationVersionSlice.actions;

export const applicationVersionSelectors = {
  selectApplicationVersionNumber: (state: RootState) =>
    state.applicationVersion.applicationVersionNumber,
  selectLatestBuildTimestamp: (state: RootState) =>
    state.applicationVersion.latestBuildTimestamp,
};

export default applicationVersionSlice.reducer;
